import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/**
 * Labeled detail row used inside summary cards (Bridge, Swap, Approvals
 * confirmation surfaces, etc). Mirrors the affiliate "stat list" pattern:
 * faint divider, muted label on the left, prominent value on the right.
 */
export function KeyValue({
  label,
  value,
  mono = false,
  className,
}: {
  label: ReactNode;
  value: ReactNode;
  mono?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-3 border-b border-foreground/8 py-2.5 text-sm last:border-b-0',
        className,
      )}
    >
      <span className="text-muted-foreground text-[12px] font-medium uppercase tracking-wider">
        {label}
      </span>
      <span
        className={cn(
          'text-foreground text-right text-sm font-medium tabular-nums',
          mono && 'font-mono text-[13px]',
        )}
      >
        {value}
      </span>
    </div>
  );
}
